import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fa-metrics-grpahs',
  templateUrl: './metrics-grpahs.component.html',
  styleUrls: ['./metrics-grpahs.component.scss']
})
export class MetricsGrpahsComponent implements OnInit {
  @Input() data: any = [];
  metrics: any;

  constructor() { }

  ngOnInit(): void {
    if (this.data) {
      this.calculateAverages();
    }
  }


  calculateAverages(): void {
    let totalVisaScore = 0;
    let totalCommunication = 0;
    let totalBodyLanguage = 0;
    let count = this.data.length;

    for (let record of this.data) {
      
      totalVisaScore += parseInt(record?.averageVisaScore, 10);
      totalCommunication += parseInt(record?.averageCommunication, 10);
      totalBodyLanguage += parseInt(record?.averageBodyLanguage, 10);
    }

    this.metrics = [
      { name: 'Visa Readiness', score: +(totalVisaScore / count).toFixed(2) },
      { name: 'Communication', score: +(totalCommunication / count).toFixed(2) },
      { name: 'Body Language', score: +(totalBodyLanguage / count).toFixed(2) }
    ];
  }



}
